package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

val SeparatorStyle = CssStyle {
    base {
        Modifier.padding(leftRight = 16.px)
    }
    Breakpoint.MD {
        Modifier.padding(leftRight = 40.px)
    }
    Breakpoint.LG {
        Modifier.padding(leftRight = 50.px)
    }
}